import { ValueDisplayValue } from "./ValueDisplayValue";

export class DbDisplayValue extends ValueDisplayValue {
    // Maintaining this empty class in case we decide we need logic specific to DbDisplayValues later on
}